import { useQuery, UseQueryOptions } from 'react-query'

import { useCurrentSite } from '../../components/SitesProvider'
import request from '../../config/axios'
import queryClient from '../../config/react-query'
import QueryKeys from './QueryKeys'

interface TableauToken {
  workbookUrl: string
  section?: string
  id?: string
}

interface TableauTokenResponse {
  tableauToken: string
}

const useTableauToken = (
  { workbookUrl, section, id }: TableauToken,
  extraOptions: UseQueryOptions = {},
) => {
  // const currentUser = useUser()
  const currentSiteId = useCurrentSite()?.id

  const url = `/impacts/tableau_token?site_ids[]=${currentSiteId}`
  const typeParam = section ? section : 'default'
  const key = QueryKeys.tableauToken(typeParam, workbookUrl, id)

  return useQuery(
    key,
    () =>
      request
        .get<TableauTokenResponse>(url, {
          params: {
            // study_id: currentStudyId,
            id: id,
            type: typeParam,
          },
        })
        .then((r) => {
          queryClient.invalidateQueries(
            QueryKeys.tableauToken(typeParam, workbookUrl, id),
          )
          return r.data.tableauToken
        }),
    {
      ...extraOptions,
      // staleTime: 0,
      // cacheTime: 0,
      // refetchInterval: 0,
    },
  )
}

export default useTableauToken
